module.exports = __webpack_public_path__ + "static/media/artist_workshop_site.e4609315.jpg";